var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68697 2.1584L5.45625 1.91269C6.17624 1.68269 6.94624 2.05483 7.2548 2.78197L7.86908 4.23052C8.13694 4.86123 7.98837 5.60337 7.50194 6.06479L6.14982 7.34906C6.23339 8.11763 6.49124 8.87405 6.92409 9.61832C7.33539 10.3384 7.88699 10.9687 8.54622 11.4719L10.1719 10.929C10.7876 10.724 11.4583 10.9605 11.8362 11.5154L12.7162 12.8083C13.1562 13.454 13.0769 14.344 12.5319 14.8911L11.9476 15.4775C11.3662 16.0611 10.5362 16.2733 9.76763 16.0333C7.95408 15.4675 6.28696 13.7883 4.76554 10.9955C3.24199 8.19834 2.70485 5.82408 3.1527 3.87553C3.34127 3.05554 3.92555 2.40197 4.6884 2.1584",
    fill: "#060606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.279197ab00d3d59688b91f55d1104f86.svg";
export { ForwardRef as ReactComponent };